import SHSearch from "../../component/BMCSearch";
import {Col, Row, Table} from "react-bootstrap";
import React, {Dispatch, SetStateAction, useEffect, useRef, useState} from "react";
import Datatables, {getCheckedItems} from "../../component/Datatables";
import BMCDatePicker from "../../../components/common/BMCDatePicker";
import CustomDatePickerRange from "../../component/ui/DatePickerRange";
import axios from "axios";
import {toast} from "react-toastify";
import errorCodeDic from "../../../util/errorCodeDic";
import BMCDatePicker2 from "../../../components/common/BMCDatePicker2";
import {DateHelper} from "../../../helper/DateHelper";
import BMCIconButton from "../../../components/common/BMCIconButton";
import messageCodeDic from "../../../util/messageCodeDic";

interface IProps {
   dataList: any;
   setSelData: Dispatch<SetStateAction<any>>;
   srchData: any;
   setSrchData: Dispatch<SetStateAction<boolean>>;
   isDatePopupOpen: boolean;
   setIsDatePopupOpen: Dispatch<SetStateAction<boolean>>;
   onSearch: any;
   setModalIsOpen: Dispatch<SetStateAction<boolean>>;
}

const FcltySftyPlanPage = (props: IProps) => {
    const prodRef = useRef<any>();
    const [startDate, setStartDate] = useState<Date>(DateHelper.dateByMonth(-1));
    const [endDate, setEndDate] = useState<Date>(DateHelper.dateByMonth(0));
    const [datatable, setDatatable] = useState<any>();

    const fn_setSrchData = (e: any) => {

        props.setSrchData({
            ...props.srchData,
            [e.target.name]: e.target.value
        })

    }

    const fn_registPopOpen = () => {
        props.setModalIsOpen(true);
        props.setSelData(null);
    }
    const fn_delete = () => {
        let checkedData = getCheckedItems(datatable,"sftyChkSeq")
        if (checkedData.length == 0) {
            toast.warn(messageCodeDic['005']);
            return;
        }
        if(!window.confirm(messageCodeDic['004'])){
            return;
        }
        axios.post('/admin/api/siteSftyManage/deleteSftyWrkMetData', {delList: checkedData}).then(rsltData => {
            if (rsltData.data > 0) {
                toast.success(messageCodeDic['002'])
                props.setSrchData(Object.assign({},props.srchData));
            } else {
                toast.error(errorCodeDic['003'])
            }
        }).catch(() => {
            toast.error(errorCodeDic['003'])
        })
    }

    return(
        <>

            <SHSearch btnType={'p'} onSearch={props.onSearch}>
                <Row>
                    <Col>
                        <Table className="bmc-font-SP bmc-fs-b2 my-3">
                            <tbody>
                            <tr className="align-middle border-bottom">
                                <th className="bmc-bg-th">기간</th>
                                <td colSpan={2}>
                                    <div className="d-flex flex-row gap-2">
                                        <div className="d-flex align-items-center" ref={prodRef}>
                                            <BMCDatePicker2 name={'strtDt'} readOnly={true} defaultValue={startDate} value={props.srchData.strtDt}  onChange={fn_setSrchData} />
                                            <span>&nbsp;~&nbsp;</span>
                                            <BMCDatePicker2 name={'endDt'} readOnly={true} defaultValue={endDate} value={props.srchData.endDt} onChange={fn_setSrchData} />
                                        </div>

                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </Table>
                    </Col>
                </Row>
            </SHSearch>
            <div className='w-100 d-flex justify-content-end align-items-center mb-2'>

                <BMCIconButton kind={'submit'} marginRight={'5px'} onClick={fn_registPopOpen}> 계획등록
                </BMCIconButton>

                <BMCIconButton kind={'delete'} marginRight={'0'} onClick={fn_delete}> 삭제
                </BMCIconButton>

            </div>

            <div className={'ge-result'}>
                <Datatables
                    datas={props.dataList}
                    scrollY="550px"
                    className="bmc-fs-b4"
                    columns={[
                        {data: "sftyDgnsGbNm", title: "구분"},
                        {data: "efctDt", title: "시행일"},
                        {data: "budget", title: '예산', render: function (data: any) {
                            return data?.toLocaleString() + ' (천원)';
                            }},
                        {data: "ivstSprvDprtGbNm", title: "현장점검", textAlign: 'center'},
                        {data: 'sftyChkRsltRgstrNm', title: '점검자'}
                    ]}
                    index={true}
                    checked={true}
                    onLoad={(dt: any) => {
                        setDatatable(dt)
                    }}

                    onClick={(data) => {
                        console.log('selData: ', data);
                        props.setSelData(Object.assign({}, data));
                    }
                    }
                />


            </div>
        </>
        )

}

export default FcltySftyPlanPage;
